import { useLayoutEffect, useState } from "react"

export function useElement(
	id: string,
	fallback: HTMLElement | null = document.body,
) {
	const [element, setElement] = useState<HTMLElement | null>(
		() => document.getElementById(id) ?? fallback,
	)

	useLayoutEffect(() => {
		const el = document.getElementById(id)
		if (el) {
			setElement(el)
		}
	}, [id])

	return element
}
